import api from '../api';

/**
 * Fetches status statement reports for a given store within a specified date range.
 *
 * @param {string} storeCode - The code of the store.
 * @param {string} startDate - The start date in RFC3339 format.
 * @param {string} endDate - The end date in RFC3339 format.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getStatusStatement = async (storeCode, startDate, endDate) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/statistic/getStatusStatement`;

  try {
    const response = await api.post(endpoint, {
      storeCode,
      startDate,
      endDate,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching status statement:', error);
    throw error;
  }
}

export default getStatusStatement;
